<template>
  <Sheet>
    <Sheet.Body class="px-0!">
      <template v-if="isReport">
        <Sheet.MenuItem :icon="DownloadIcon" @click="handleDownload">
          Download report
        </Sheet.MenuItem>
        <Sheet.MenuItem :icon="ShareIcon" @click="handleShare">
          Share
        </Sheet.MenuItem>
      </template>

      <Sheet.MenuItem v-else :icon="FileAddIcon" @click="handleGetReport">
        Get report
      </Sheet.MenuItem>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { Sheet, useSheet } from '@dacr/library'
import { DownloadIcon, FileAddIcon, ShareIcon } from '@dacr/icons'
import {
  InfringementLabel,
  type InfringementListQuery,
} from '@/shared/graphql/router/graphql'
import { openDialog, Dialog } from '@/shared/dialogs/dialog'

type InfringementNode =
  InfringementListQuery['infringements']['edges'][number]['node']

const props = defineProps<{
  infringement: InfringementNode
}>()

const { close } = useSheet()
const router = useRouter()

const isReport = computed(
  () => props.infringement.label === InfringementLabel.Report
)

const handleDownload = () => {
  close()
  router.push(`/infringement/report/${props.infringement.report?.id}`)
}

const handleShare = () => {
  close()
  openDialog(Dialog.ShareReport, {
    props: { report: props.infringement.report },
  })
}

const handleGetReport = () => {
  close()
  openDialog(Dialog.FlaggedMatch, {
    props: { infringement: props.infringement },
  })
}
</script>
